import { AxiosRequestConfig } from "axios";

export const prepareAxiosRequestConfig = async (
  config: AxiosRequestConfig,
): Promise<AxiosRequestConfig> => {
  // HttpOnly cookie session: browser sends credentials; no Bearer header.

  return config;
};

/*
Emergency rollback — Bearer + localStorage + silent refresh.
Restore these imports at the top of the file, then replace the function body with the block below (remove the early return above).

import { jwtDecode } from "jwt-decode";
import {
  MILLISECONDS_IN_SECOND,
  TOKEN_REFRESH_MARGIN_SECONDS,
} from "../../constants";
import { IJwtPayload } from "../../models";
import { showTokenExpiredAlert } from "../api-utils";
import { Log } from "../log.helpers";
import { storeCurrentPageAndRedirectToLogin } from "../url.helpers";
import { getAccessToken, getRefreshToken } from "./auth.helpers";
import { logRefreshTokenExpiration, logTokenExpiration } from "./token-logging";
import {
  getTokenIsRefreshing,
  refreshAccessToken,
} from "./token-refresh.helpers";

--- function body to paste ---

  let accessToken: string | null | undefined = getAccessToken();

  if (!accessToken) {
    return config;
  }

  const now = Date.now() / MILLISECONDS_IN_SECOND;
  let exp: number | undefined;

  try {
    ({ exp } = jwtDecode<IJwtPayload>(accessToken));
    logTokenExpiration(accessToken);
  } catch {
    return config;
  }

  const refreshToken = getRefreshToken();

  if (!refreshToken && exp && now > exp) {
    showTokenExpiredAlert();
    storeCurrentPageAndRedirectToLogin();
    return config;
  }

  if (refreshToken) {
    logRefreshTokenExpiration(refreshToken);

    try {
      if (exp && now > exp - TOKEN_REFRESH_MARGIN_SECONDS) {
        if (getTokenIsRefreshing()) {
          Log.debug("Token refreshing already in progress");
          await refreshAccessToken();
          accessToken = getAccessToken();
        } else {
          Log.debug("Silent token refresh on api call");
          await refreshAccessToken();
          accessToken = getAccessToken();
        }

        if (!accessToken) {
          showTokenExpiredAlert();
          storeCurrentPageAndRedirectToLogin();
          return config;
        }
      }
    } catch (e) {
      Log.warn("Error refreshing token silently", e);

      if (exp && now > exp) {
        showTokenExpiredAlert();
        storeCurrentPageAndRedirectToLogin();
        return config;
      }

      return config;
    }
  }

  config.headers = {
    ...config.headers,
    Authorization: `Bearer ${accessToken}`,
  };

  return config;
*/
